// 首页 主模块 灵犀 bid
const lxBid = {
    pageid: '40035613', // 页面pageid
    cid: 'c_ywm5nx3j', // 页面cid
    hotViewBid: 'b_dgyveg45', // 热门商区曝光bid ok ok ok
    cataNavClickBid: 'b_raafmbo6', // 左侧楼层点击bid ok ok ok
    cataNavViewBid: 'b_rafkzld8', // 左侧楼层曝光bid ok ok ok
    poiViewBid: 'b_30r7osop', // 商户poi曝光 ok ok ok
    headlineClickBid: 'b_vguvvy6a', // 点评头条点击 ok ok
    headlineViewBid: 'b_m63qith6', // 点评头条曝光 ok ok ok
    userInfoClickBid: 'b_pe5v3cf7', // 个人信息点击 ok ok ok
    picClickBid: 'b_qe2rysdx', // 图片商户点击 ok ok ok
    userInfoViewBid: 'b_1hp26mnj', // 个人信息曝光 ok ok ok
    bannerClickBid: 'b_r2p0d76c', // 运营图点击 ok ok ok
    hotClickBid: 'b_7hjo5cam', // 热门商区点击 ok ok ok
    socialInfoClickBid: 'b_ulpmhwxn', // 社区标题点击 ok ok ok
    tagClickBid: 'b_zebz3ssh', // 模块标签点击 ok  ok ok
    tagViewBid: 'b_tvpdo5aw', // 模块标签曝光 ok ok ok
    poiClickBid: 'b_4n692i6y', // 商户poi点击 ok ok ok
    vipClickBid: 'b_tp9ff58y', // VIP排行点击 ok ok ok
    vipViewBid: 'b_wvuzphai', // VIP排行爆光 ok ok ok
    tribeClickBid: 'b_mn6kn1mj', // 部落点击 ok ok ok
    tribeViewBid: 'b_rhxuoyq8', // 部落曝光 ok ok ok
    noLoginClickBid: 'b_yaixts4r', // 未登录点击 ok ok ok
    noLoginViewBid: 'b_e4dfmz2t', // 未登录曝光 ok ok ok
    postClickBid: 'b_m0vw9q4v', // 热帖点击 ok ok ok
    postViewBid: 'b_qurzjr79', // 热帖曝光 ok ok ok ok
    picViewBid: 'b_marr0szt' // 图片商户曝光 ok ok  ok
}

module.exports = lxBid



// WEBPACK FOOTER //
// ./src/lib/lx-bid.js